/* Ephesia Soul V2. No login, catalogue, cart or authentication actions. */
(function () {
  'use strict';
  var translations = {"tr":{"eyebrow":"ÇOK YAKINDA","h1":"Anadolu’nun ruhu,","h2":"çok yakında sizinle.","description":"Doğal dokular, zamansız tasarımlar ve Akdeniz’in sakinliği. Ephesia Soul’un dünyasıyla buluşmanıza çok az kaldı.","contact":"Bize ulaşın","collection":"Banyo · Spa · Yaşam","bottom":"Anadolu’dan ilhamla. Dünya için özenle.","rights":"Tüm hakları saklıdır.","title":"Ephesia Soul | Çok yakında","nav":"Dil seçimi"},"en":{"eyebrow":"COMING SOON","h1":"The soul of Anatolia.","h2":"Soon, a part of your world.","description":"Natural textures, timeless design and the quiet of the Mediterranean. A new world of Ephesia Soul is taking shape.","contact":"Get in touch","collection":"Bath · Spa · Living","bottom":"Inspired by Anatolia. Crafted for the World.","rights":"All rights reserved.","title":"Ephesia Soul | Coming soon","nav":"Choose language"},"sk":{"eyebrow":"UŽ ČOSKORO","h1":"Duša Anatólie.","h2":"Čoskoro aj vo vašom svete.","description":"Prírodné textúry, nadčasový dizajn a pokoj Stredomoria. Svet Ephesia Soul už čoskoro otvorí svoje dvere.","contact":"Kontaktujte nás","collection":"Kúpeľ · Spa · Životný štýl","bottom":"Inšpirované Anatóliou. Tvorené pre svet.","rights":"Všetky práva vyhradené.","title":"Ephesia Soul | Už čoskoro","nav":"Výber jazyka"}};
  function cleanAddress(root) {
    // Cosmetic address-bar update only. The server-side password gate is NOT disabled.
    // A refresh still visits Shopify's protected endpoint; no password/cookies are changed.
    if (root.dataset.esPasswordPage !== 'true' || root.dataset.esEditor === 'true') return;
    try {
      if (window.top !== window.self || (window.Shopify && window.Shopify.designMode)) return;
      var current = new URL(window.location.href);
      if (!/\/password\/?$/.test(current.pathname)) return;
      current.pathname = current.pathname.replace(/\/password\/?$/, '/') || '/';
      window.history.replaceState(window.history.state, '', current.pathname + current.search + current.hash);
    } catch (_) { /* Keep the working password URL if history access is unavailable. */ }
  }
  function init(root) {
    if (!root || root.dataset.esReady === 'true') return;
    root.dataset.esReady = 'true';
    var buttons = root.querySelectorAll('[data-es-language]');
    function apply(code, manual) {
      if (!Object.prototype.hasOwnProperty.call(translations, code)) code = 'en';
      var t = translations[code];
      root.querySelectorAll('[data-es-copy]').forEach(function (node) {
        var value = t[node.dataset.esCopy];
        if (typeof value === 'string') node.textContent = value;
      });
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.esLanguage === code)); });
      var nav = root.querySelector('.es-languages');
      if (nav) nav.setAttribute('aria-label', t.nav);
      root.lang = code;
      document.documentElement.lang = code;
      document.title = t.title;
      var meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', t.description);
      if (manual) {
        try { sessionStorage.setItem('ephesia-coming-soon-lang', code); } catch (_) {}
      }
    }
    var locale = root.dataset.defaultLanguage || 'en';
    try {
      var explicit = new URLSearchParams(window.location.search).get('lang');
      var saved = sessionStorage.getItem('ephesia-coming-soon-lang');
      var browser = (navigator.language || '').split('-')[0].toLowerCase();
      locale = explicit || saved || (translations[browser] ? browser : locale);
    } catch (_) {}
    apply(locale, false);
    buttons.forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.esLanguage, true); }); });
    cleanAddress(root);
  }
  document.querySelectorAll('[data-es-coming-soon]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-es-coming-soon]').forEach(init); });
})();
